export default {
    pages: {
        key: "title",
        data: [
            /*{title: 'Home', url: '/', icon: 'HomeIcon', is_bookmarked: false},
            {title: 'Page 2', url: '/page2', icon: 'FileIcon', is_bookmarked: false},*/
            {title: 'Dashboard', url: '/user', icon: 'GridIcon', is_bookmarked: false},
            //{title: 'Admin View', url: '/admin', icon: 'UserIcon', is_bookmarked: false},
            {title: 'Descendant View', url: '/user/downline', icon: 'UserIcon', is_bookmarked: false},
            {title: 'Transactions View', url: '/user/activity', icon: 'DollarSignIcon', is_bookmarked: false},
            {title: 'Tree View', url: '/user/mlm-bonus', icon: 'Transactions View', is_bookmarked: false},
            {title: 'Withdrawal View', url: '/user/withdrawal', icon: 'EditIcon', is_bookmarked: false},
        ]
    }
}
